// bootstrap vue
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
// mdb vue
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbvue/lib/css/mdb.min.css';
// core vue
import Vue from "vue";
import App from "./App.vue";
import axios from 'axios';
// import './registerServiceWorker';
// import { i18n } from '@/i18n';
import VueAxios from 'vue-axios';
// import VueCookies from 'vue-cookies';
import VueMq from 'vue-mq'; // no typescript support, but more functionality
import VueMediaQ from 'vue-media-q'; // better typescript support, but less functionality
import router from "./router";
import store from "./store";

Vue.config.productionTip = false;
Vue.use(VueAxios, axios);
Vue.use(BootstrapVue);
// Vue.use(VueClosable);
// Vue.use(VueCookies);
// Vue.use(VueSidebarMenu);

Vue.use(VueMq, {
  breakpoints: {
    sm: 450,
    md: 1250,
    lg: Infinity
  },
  defaultBreakpoint: 'sm'
});

Vue.use(VueMediaQ, {
  xs: 425,
  sm: 769,
  md: 992,
  lg: Infinity
});

new Vue({
  // i18n,
  router,
  store,
  render: h => h(App)
}).$mount("#app");
